export default function Divider({ className = "" }: { className?: string }) {
  return (
    <div
      className={`flex items-center justify-center gap-4 text-[var(--color-gold)] ${className}`}
      aria-hidden
    >
      <span
        className="h-px w-16 origin-right bg-gradient-to-l from-[var(--color-gold)] via-[var(--color-rule)] to-transparent md:w-28"
        style={{ animation: "var(--animate-rule-draw)" }}
      />
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        className="shrink-0"
        style={{ animation: "var(--animate-ember)" }}
      >
        <path
          d="M11 2 C12.5 6, 16 7.5, 20 8 C16 8.5, 12.5 10, 11 14 C9.5 10, 6 8.5, 2 8 C6 7.5, 9.5 6, 11 2 Z"
          fill="currentColor"
        />
        <circle cx="11" cy="17" r="1.2" fill="currentColor" />
      </svg>
      <span
        className="h-px w-16 origin-left bg-gradient-to-r from-[var(--color-gold)] via-[var(--color-rule)] to-transparent md:w-28"
        style={{ animation: "var(--animate-rule-draw)" }}
      />
    </div>
  );
}
